import Crud from '../views/Product/Crud'
import Entity from '../views/Product/Add'

let routes = {
    path: '/products',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/products/add',
            name: 'NewProduct',
            component: Entity,
            meta: {
                pageTitle: 'Produto',
                breadcrumb: [
                    { text: 'Produto', active: false, to: '/products' },
                    { text: 'Adicionar Produto', active: true }
                ],
            },
        },
        {
            path: '/products/edit/:id?',
            name: 'EditProduct',
            component: Entity,
            meta: {
                pageTitle: 'Produto',
                breadcrumb: [
                    { text: 'Produto', active: false, to: '/products' },
                    { text: 'Editar Produto', active: true }
                ],
            },
        },
        {
            path: '/products',
            name: 'list-products',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Produto', active: true },
                ],
            },
        },
    ]
};

export default routes
